import styles from './styles.module.scss';
import type { TreeNodeData } from '../models';
import { TreeNode } from './TreeNode';
import { type ReactNode, useMemo } from 'react';
import { NodeDataContext } from './NodeDataContext';
import { ZoomInfoContext } from './ZoomInfoProvider';

export type SkillTreeProps = {
  skillsConfig: TreeNodeData[];
  linkComponent: ({ skill }: { skill: TreeNodeData }) => ReactNode;
  children: ({ skill }: { skill: TreeNodeData }) => ReactNode;
  zoom?: number;
};

export const SkillTree = ({ skillsConfig, linkComponent, children, zoom = 1 }: SkillTreeProps) => {
  const skillsMap = useMemo(
    () => new Map<string, TreeNodeData>(skillsConfig.map((skill) => [skill.id, skill])),
    [skillsConfig],
  );

  const rootSkill = skillsConfig[0];

  if (skillsConfig.length === 0) {
    console.error(`The Skills list cannot be empty`);

    return null;
  }

  return (
    <div className={styles.skillTree}>
      <ZoomInfoContext.Provider value={zoom}>
        <NodeDataContext.Provider value={skillsMap}>
          <TreeNode
            link={linkComponent}
            isRoot
            key={rootSkill.id}
            skill={rootSkill}
            direction={rootSkill.subTreeConfig?.direction || 0}
          >
            {children}
          </TreeNode>
        </NodeDataContext.Provider>
      </ZoomInfoContext.Provider>
    </div>
  );
};
